
<script>
    const PatientService = {}

    PatientService.install = function (Vue) {

        var patientService = new Object ();

        Object.defineProperty(Vue.prototype, '$patientService', { value: patientService });

        patientService.search = function (searchQuery, page = 0, size = 10, options = {}) {
            var url = '/api/admin/patient/search?page=' + page + '&size=' + size;
            if (searchQuery) {
                url += '&q=' + encodeURIComponent(searchQuery);
            }
            if (options.email) {
                url += '&email=true';
            }
            if (options.payment && options.payment !== 'all') {
                url += '&payment=' + encodeURIComponent(options.payment);
            } else if (options.pending) {
                url += '&pending=true';
            }
            return Vue.axios.get(url)
                .then(response => { return response.data; })
                .catch(error => {
                    this.handleError(error)
                    return Promise.reject(error);
            });
        };

        patientService.searchByEmail = function (searchQuery, page = 0, size = 10) {
            var url;
            if (searchQuery) {
                url = '/api/admin/patient/search?q=' + searchQuery + '&email=true&page=' + page + '&size=' + size;
            } else {
                url = '/api/admin/patient/search?page=' + page + '&size=' + size;
            }
            return Vue.axios.get(url)
                .then(response => { return response.data; })
                .catch(error => {
                    this.handleError(error)
                    return Promise.reject(error);
            });
        };

        patientService.getBookerPatientRelationship = function (bookerId, patientId) {
            var url = '/relation/' + bookerId + '/' + patientId;
            return Vue.axios.get(url)
                .then(response => { return response.data; })
                .catch(error => {
                    this.handleError(error);
                    return Promise.reject(error);
            });
        };

        patientService.getPatient = function (id) {
            var url = '/api/admin/patient/' + id;
            return Vue.axios.get(url)
                .then(response => { return response.data; })
                .catch(error => {
                    this.handleError(error);
                    return Promise.reject(error);
            });
        };

        patientService.createPatient = function (payload) {
            return Vue.axios.post('/api/admin/patient', payload)
                .then(response => { return response.data; })
                .catch(error => {
                    this.handleError(error);
                    return Promise.reject(error);
                });
        };

        /** Holds the chosen slot for this patient so the payment link doesn't ask them to pick a time again. */
        patientService.holdSlotForPaymentLink = function (patientId, payload) {
            return Vue.axios.post('/api/admin/patient/' + patientId + '/slot-hold', payload)
                .then(response => { return response.data; });
        };

        /** Emails a set-password link (account admin created, no password yet) or else a normal reset link. */
        patientService.sendSetPasswordLink = function (patientId) {
            return Vue.axios.post('/api/admin/patient/' + patientId + '/set-password-link')
                .then(response => { return response.data; });
        };

        patientService.cancelSlotHold = function (patientId) {
            return Vue.axios.delete('/api/admin/patient/' + patientId + '/slot-hold')
                .then(response => { return response.data; });
        };

        patientService.savePaymentLink = function (patientId, url) {
            return Vue.axios.post('/api/admin/patient/' + patientId + '/payment-link', { url: url })
                .then(response => { return response.data; })
                .catch(error => {
                    this.handleError(error);
                    return Promise.reject(error);
                });
        };

        patientService.getAdminBookingSummary = function () {
            return Vue.axios.get('/api/admin/admin-booking/summary')
                .then(response => { return response.data; })
                .catch(error => {
                    this.handleError(error);
                    return Promise.reject(error);
                });
        };

        patientService.getDefaultPaymentMethod = function (patientId) {
            var url = '/api/admin/default-payment-method/' + patientId;
            return Vue.axios.get(url)
                .then(response => { return response.data; })
                .catch(error => {
                    this.handleError(error);
                    return Promise.reject(error);
                });
        };

        patientService.getSetupIntent = function (patientId, type, mediaType) {
            var url = `/api/admin/patient/${patientId}/setup-intent/${type}/${mediaType}`;
            return Vue.axios.get(url)
                .then(response => { return response.data; })
                .catch(error => {
                    this.handleError(error);
                    return Promise.reject(error);
                });
        };

        patientService.updatePatient = function (patient) {
            var url = '/api/admin/edit-profile/patient';
            return Vue.axios.put(url, patient)
                .then(response => { return response.data; })
                .catch(error => {
                    this.handleError(error);
                    return Promise.reject(error);
            });
        };

        patientService.handleError = function(error) {
            if (error.response) {
                // The request was made and the server responded with a status code that falls out of the range of 2xx
                console.debug(error.response.data);
                console.debug(error.response.status);
                console.debug(error.response.headers);
                return {
                  success: false,
                  message: error.response.message,
                  status: error.response?.status,
                };
            } else if (error.request) {
                // The request was made but no response was received `error.request` is an instance of XMLHttpRequest in the browser and an instance of http.ClientRequest in node.js
                // Vue.$router.push('/login')
                console.debug('error.request ', error.request);
              return {
                success: false,
                message: 'Did not receive a response from the server.',
              };
            } else {
                // Something happened in setting up the request that triggered an Error
                // Vue.$router.push('/login')
                console.debug('error', error.request);
              return {
                success: false,
                message: 'Failed to make the request.',
              }
            }
        };

        patientService.updatePatientSetting = function(patientId, settingKey, settingValue) {
          const url = `/api/admin/patient/${patientId}/setting/${settingKey}`;
          const encodedValue = encodeURI(settingValue);
          return Vue.axios.post(`${url}/${encodedValue}`)
          .then(response => ({
            success: true,
            data: response.data
          }))
          .catch(error => this.handleError(error))
        }

      patientService.removePatientSetting = function(patientId, settingKey) {
        const url = `/api/admin/patient/${patientId}/setting/${settingKey}`;
        return Vue.axios.delete(url)
            .then(response => ({
              success: true,
              data: response.data
            }))
            .catch(error => this.handleError(error))
      }
    }

    export default PatientService;
</script>
